import { Provider, DOCUMENT } from '@angular/core';
import { DomResourceService, LogService, TOKENS as TOKENS_COMMON } from '@trustedshops/tswp-core-common';
import {
  TOKENS as TOKENS_ANALYTICS,
  TrackerFactory,
  TrackerType,
} from '@trustedshops/tswp-core-analytics';
import {
  GoogleAnalyticsTrackerFactory,
  HubSpotAnalyticsTrackerFactory,
  MSClarityAnalyticsTrackerFactory,
  TrackingServiceImpl
} from '@trustedshops/tswp-core-analytics-implementation';

import { IdentityService } from 'packages/tswp-core-authorization/src/lib/services/identity.service.interface';
import { TOKENS as TOKENS_AUTHORIZATION } from '@trustedshops/tswp-core-authorization';

export const TrackingConfiguration: Provider[] = [
  {
    provide: TOKENS_ANALYTICS.TrackerFactories,
    useFactory: (domResourceService: DomResourceService, document: Document, logService: LogService) =>
      new GoogleAnalyticsTrackerFactory(domResourceService, document, logService),
    deps: [TOKENS_COMMON.DomResourceService, DOCUMENT, TOKENS_COMMON.LogService],
    multi: true
  },
  {
    provide: TOKENS_ANALYTICS.TrackerFactories,
    useFactory: (domResourceService: DomResourceService, document: Document, logService: LogService) =>
      new HubSpotAnalyticsTrackerFactory(domResourceService, document, logService),
    deps: [TOKENS_COMMON.DomResourceService, DOCUMENT, TOKENS_COMMON.LogService],
    multi: true
  },
  {
    provide: TOKENS_ANALYTICS.TrackerFactories,
    useFactory: (document: Document, logService: LogService, identityService: IdentityService) =>
      new MSClarityAnalyticsTrackerFactory(document, logService, identityService),
    deps: [DOCUMENT, TOKENS_COMMON.LogService, TOKENS_AUTHORIZATION.IdentityService],
    multi: true
  },
  {
    provide: TOKENS_ANALYTICS.TrackingService,
    useFactory: (logService: LogService, trackerFactories: TrackerFactory<TrackerType>[]) =>
      new TrackingServiceImpl(logService, trackerFactories),
    deps: [TOKENS_COMMON.LogService, TOKENS_ANALYTICS.TrackerFactories]
  }
];
